import React, { useCallback, useState } from 'react';
import { Modal, Row, Button, Space } from 'antd';
import { DataGridPlus, TablesFilter } from 'components/common';
import { CloseOutlined } from '@ant-design/icons';

type Props = {
  onHide: () => void;
  onOk: (selectedReturn: any) => void;
  returnList: any[];
};
// eslint-disable-next-line
export default (props: Props) => {
  const { onHide, returnList, onOk } = props;
  const [filteredData, setFilteredData] = useState<any[]>([]);
  // const [selected, setSelected] = useState<PoRow>();
  /**
   * handle hide event
   */
  const handleHide = useCallback(() => {
    onHide();
  }, [onHide]);

  // const handleOk = useCallback(() => {
  //   if (selected) {
  //     onOk(selected);
  //     onHide();
  //   }
  // }, [selected, onHide, onOk]);
  const columns = [
    // {
    //   header: '',
    //   dataIndex: 'po',
    //   maxWidth: 50,
    //   render: (value: any) => {
    //     const { data } = value;
    //     return (
    //       <Radio
    //         checked={data.poNumber === selected?.poNumber}
    //         onClick={() => {
    //           console.log(data);
    //           setSelected(data);
    //         }}
    //       />
    //     );
    //   },
    // },
    {
      header: 'Order',
      name: 'channelOrderId',
      defaultFlex: 1,
    },
    {
      header: 'Custom Name',
      name: 'shipToName',
      defaultFlex: 1,
      render: (value: any) => {
        const { data } = value;
        return data.shipToName || data.endBuyerName;
      },
    },
  ];
  return (
    <Modal
      title="Return List"
      centered
      visible={true}
      width={800}
      destroyOnClose={true}
      onCancel={handleHide}
      getContainer={false}
      footer={
        <Row justify="end">
          <Space>
            <Button id="cancel_button" onClick={handleHide} icon={<CloseOutlined />}>Cancel</Button>
            {/* <Button type="primary" onClick={handleOk}>
              Use Selected
            </Button> */}
          </Space>
        </Row>
      }
    >
      <TablesFilter
        columns={columns}
        dataSource={returnList}
        setFilteredData={setFilteredData}
      />
      <DataGridPlus
        columns={columns}
        onRowClick={(row) => {
          onOk(row.data);
        }}
        dataSource={filteredData}
        idProperty="ponum"
        pagination="local"
        {...({} as any)}
      />
    </Modal>
  );
};
